import { type WrappedInsightAllHoursChampionAttributes } from "@clipboard-health/contract-backend-main";
import { Image, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

import candleIcon from "../../assets/candle-wrapped.png";

interface AllHoursChampionContentProps {
  attributes: WrappedInsightAllHoursChampionAttributes;
}

export function AllHoursChampionContent(props: AllHoursChampionContentProps) {
  const { attributes } = props;

  return (
    <Stack flex={1} position="relative" overflow="hidden">
      {/* Candle image - positioned based on Figma: 240x240 at top 335px, left 148.5px on 375x812 page */}
      <Box
        position="absolute"
        sx={{
          top: "35%", // 335 / 812 = 41.3%
          left: "39.6%", // 148.5 / 375 = 39.6%
        }}
      >
        {/* Glow effect behind candle */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "200%",
            height: "200%",
            background:
              "radial-gradient(circle, rgba(255,248,220,0.8) 0%, rgba(255,248,220,0) 70%)",
            pointerEvents: "none",
          }}
        />
        <Image
          src={candleIcon}
          alt="Candle"
          width="64vw" // 240 / 375 = 64%
          height="auto"
          sx={{ position: "relative" }}
        />
      </Box>

      {/* Text section - bottom left */}
      <Stack
        position="absolute"
        sx={{
          bottom: "12%",
          left: "7.7%",
        }}
        gap={1}
      >
        <Text variant="body1" color="white">
          You are an
        </Text>
        <Text variant="h1" color="white" sx={{ fontSize: "3.5rem", lineHeight: 1 }}>
          All-Hours
        </Text>
        <Text variant="h1" color="white" sx={{ fontSize: "3.5rem", lineHeight: 1 }}>
          Champion
        </Text>
        <Text variant="body2" color="white" sx={{ marginTop: 2 }}>
          {attributes.amShifts} AM Shifts · {attributes.pmShifts} PM Shifts · {attributes.nocShifts}{" "}
          NOC Shifts
        </Text>
      </Stack>
    </Stack>
  );
}
